import { OpenpanelService } from '../services/openpanel.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ItineraryServiceService, ConfirmService, DataService, CarrierLogoService } from '../services/index'
import { Error } from '../models/index'
import { Base64 } from 'js-base64';
import mixpanel from 'mixpanel-browser';
import { environment } from '../../environments/environment';
import { FaroService } from '../services/faro.service';

@Component({
    selector: 'app-confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.css'],
    standalone: false
})
export class ConfirmComponent implements OnInit, OnDestroy {
  sub:any;
  confirmData:any;
  res:any;
  isError:boolean;
  errorMessage:any;
  successMessage:any;
  isWaiting:boolean;
  isSaving:boolean
  waitingMessage:any;
  api_error:Error;
  isHidden:boolean = true;
  passData:any;

  private ws: WebSocket;
  private wsTimeout: any;
  private wsPollInterval: any;
  private wsClosedIntentionally = false;
  private httpPollInterval: any;
  private httpPollCount = 0;
  private readonly HTTP_POLL_MAX = 18; // 18 × 10s = 3 minutes
  // confirmMpesa's own retry loop below has no bounded attempt count (retries
  // every 10s indefinitely), so there's no natural "exhausted" event like the
  // other polling paths have - fire once when it first enters that state
  // instead of flooding an event every 10s forever.
  private legacyConfirmRetryTracked = false;

  constructor(
    private openpanel: OpenpanelService,
    private router: Router,
    private route: ActivatedRoute,
    private service: ConfirmService,
    private itenaryservice:ItineraryServiceService,
    private dataService: DataService,
    public carrierLogoService: CarrierLogoService,
    private faroService: FaroService
  ) { }

  ngOnInit() {
    this.dataService.confirmValueChange.subscribe(message => {

      if(!message){
        message = localStorage.getItem('cmMessage')
        if(!message) {
          this.router.navigate(['/'])
        }
      }

      if(message){
        this.confirmData = JSON.parse(atob(message));
        console.log(this.confirmData);
        let bdata = this.confirmData.data
        this.isWaiting = true;
        this.getBookingStatus(bdata.internal_booking_reference, bdata.id)
      }

    })
  }

  ngOnDestroy() {
    this.closeWebSocket();
  }

  private closeWebSocket(intentional = false) {
    this.wsClosedIntentionally = intentional;
    clearTimeout(this.wsTimeout);
    clearInterval(this.wsPollInterval);
    clearInterval(this.httpPollInterval);
    if (this.ws) {
      this.ws.onclose = null;
      this.ws.onerror = null;
      this.ws.onmessage = null;
      this.ws.close();
      this.ws = null;
    }
  }

  // Shared by all 4 success call sites below (HTTP-fallback, WebSocket
  // success + its nested getBookings success/error, legacy confirmMpesa
  // polling) - each mirrors the existing openpanel.track('payment_completed')
  // call right next to it, with whatever data is actually available there.
  private pushPaymentConfirmedFaroEvent(extra?: Record<string, any>): void {
    this.faroService.pushEvent('payment_confirmed', {
      booking_reference: this.confirmData?.data?.internal_booking_reference,
      ...extra,
    });
  }

  private startHttpFallback(internal_id, booking_id) {
    console.warn('WebSocket unavailable, falling back to HTTP polling');
    this.httpPollCount = 0;
    this.httpPollInterval = setInterval(() => {
      this.httpPollCount++;
      this.itenaryservice.getBookings(internal_id, booking_id).subscribe(
        resp => {
          const booking = resp.data[0];
          if (booking.status === 'success' || (booking.status === 'hold' && booking.payments?.payment_code)) {
            clearInterval(this.httpPollInterval);
            this.res = booking;
            mixpanel.track("Booking Success", {
              "Booking ID": this.res.internal_booking_reference,
              "Booking Reference": internal_id,
              "Booking Status": this.res.status,
              "Amount": this.res.total_amount,
              "Currency": this.res.total_currency,
              "Passengers": this.res.passengers,
              "Customer-first_name": this.res.customer_billing_details.first_name,
              "Customer-last_name": this.res.customer_billing_details.last_name,
              "Customer-email": this.res.customer_billing_details.email,
              "Customer-phone": this.res.customer_billing_details.phone_number,
              "Customer-address": this.res.customer_billing_details.address
            });
            this.isWaiting = false;
            this.successMessage = "Payment processed successfully";
            this.pushPaymentConfirmedFaroEvent({
              status: this.res.status,
              amount: this.res.total_amount,
              currency: this.res.total_currency,
            });
            this.openpanel.track('payment_completed', {}); this.router.navigate(['/booking-successful', btoa(JSON.stringify(this.confirmData))]);

          } else if (booking.status === 'cancelled') {
            clearInterval(this.httpPollInterval);
            this.res = booking;
            mixpanel.track("Booking payment Cancelled", {
              "Booking ID": booking_id,
              "Booking Reference": internal_id,
              "Booking Status": "cancelled",
              "Amount": this.res.total_amount,
              "Currency": this.res.total_currency
            });
            this.faroService.pushEvent('payment_cancelled', {
              booking_reference: internal_id,
            });
            this.isWaiting = false;
            this.isError = true;
            this.errorMessage = "Sorry your payment request was canceled. Please try again";
            const fdata = { "flight_data": this.confirmData, "isError": true, "errorMessage": 'cancelled' };
            this.dataService.changePaymentMessage(Base64.encode(JSON.stringify(fdata)));
            this.router.navigate(['/payments', Base64.encodeURI(JSON.stringify(fdata))]);

          } else if (this.httpPollCount >= this.HTTP_POLL_MAX) {
            clearInterval(this.httpPollInterval);
            this.faroService.pushEvent('payment_confirmation_poll_exhausted', {
              booking_reference: internal_id,
              attempts: this.httpPollCount,
            });
            document.getElementById("openReloadButton").click();
          }
        },
        err => {
          if (this.httpPollCount >= this.HTTP_POLL_MAX) {
            clearInterval(this.httpPollInterval);
            this.faroService.pushEvent('payment_confirmation_poll_exhausted', {
              booking_reference: internal_id,
              attempts: this.httpPollCount,
              had_error: true,
            });
            document.getElementById("openReloadButton").click();
          }
        }
      );
    }, 10000);
  }

  getBookingStatus(internal_id, booking_id) {
    this.isWaiting = true;
    this.isSaving = false;
    this.waitingMessage = "Processing your payments please wait.....";

    const wsUrl = `${environment.paymentStatusWs}${internal_id}`;
    console.log('Connecting to payment status WebSocket:', wsUrl);

    this.ws = new WebSocket(wsUrl);

    this.ws.onopen = () => {
      console.log('WebSocket connected, requesting status...');
      this.ws.send(JSON.stringify({ type: 'status_request' }));

      // Periodically re-request status while pending
      this.wsPollInterval = setInterval(() => {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
          this.ws.send(JSON.stringify({ type: 'status_request' }));
        }
      }, 5000);
    };

    this.ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log('WebSocket status:', data);

      if (data.status === 'confirmed') {
        this.closeWebSocket(true);
        // Fetch full booking details for mixpanel tracking and success page
        this.itenaryservice.getBookings(internal_id, booking_id).subscribe(
          resp => {
            this.res = resp.data[0];
            console.log('Booking confirmed:', this.res);
            mixpanel.track("Booking Success", {
              "Booking ID": this.res.internal_booking_reference,
              "Booking Reference": internal_id,
              "Booking Status": this.res.status,
              "Amount": this.res.total_amount,
              "Currency": this.res.total_currency,
              "Passengers": this.res.passengers,
              "Customer-first_name": this.res.customer_billing_details.first_name,
              "Customer-last_name": this.res.customer_billing_details.last_name,
              "Customer-email": this.res.customer_billing_details.email,
              "Customer-phone": this.res.customer_billing_details.phone_number,
              "Customer-address": this.res.customer_billing_details.address
            });
            this.isWaiting = false;
            this.successMessage = "Payment processed successfully";
            let f = btoa(JSON.stringify(this.confirmData));
            this.pushPaymentConfirmedFaroEvent({
              status: this.res.status,
              amount: this.res.total_amount,
              currency: this.res.total_currency,
            });
            this.openpanel.track('payment_completed', {}); this.router.navigate(['/booking-successful', f]);
          },
          err => {
            // Even if detail fetch fails, navigate to success since payment is confirmed
            this.isWaiting = false;
            this.successMessage = "Payment processed successfully";
            let f = btoa(JSON.stringify(this.confirmData));
            // this.res is not reliable here (this is the getBookings error
            // branch) - only the route-decoded confirmData is trustworthy.
            this.pushPaymentConfirmedFaroEvent();
            this.openpanel.track('payment_completed', {}); this.router.navigate(['/booking-successful', f]);
          }
        );

      } else if (data.status === 'cancelled') {
        this.closeWebSocket(true);
        mixpanel.track("Booking payment Cancelled", {
          "Booking ID": booking_id,
          "Booking Reference": internal_id,
          "Booking Status": "cancelled"
        });
        this.faroService.pushEvent('payment_cancelled', {
          booking_reference: internal_id,
        });
        this.isWaiting = false;
        this.isError = true;
        this.errorMessage = "Sorry your payment request was canceled. Please try again";

        let fdata = {
          "flight_data": this.confirmData,
          "isError": true,
          "errorMessage": 'cancelled'
        };
        const payJson = JSON.stringify(fdata);
        this.dataService.changePaymentMessage(Base64.encode(payJson));
        this.router.navigate(['/payments', Base64.encodeURI(payJson)]);

      } else if (data.status === 'pending') {
        this.isWaiting = true;
        this.waitingMessage = "Processing your payments please wait.....";
        // Timeout based on pay_within_mins from server
        if (data.pay_within_mins && !this.wsTimeout) {
          const timeoutMs = data.pay_within_mins * 60 * 1000;
          this.wsTimeout = setTimeout(() => {
            this.faroService.pushEvent('payment_timeout', {
              booking_reference: internal_id,
            });
            this.closeWebSocket();
            document.getElementById("openReloadButton").click();
          }, timeoutMs);
        }
      }
    };

    this.ws.onerror = (err) => {
      console.error('WebSocket error, will fall back to HTTP polling:', err);
    };

    this.ws.onclose = (event) => {
      clearInterval(this.wsPollInterval);
      clearTimeout(this.wsTimeout);
      if (!this.wsClosedIntentionally) {
        console.warn(`WebSocket closed unexpectedly (code: ${event.code}), falling back to HTTP polling`);
        this.startHttpFallback(internal_id, booking_id);
      }
    };

    // Global fallback timeout (10 minutes)
    if (!this.wsTimeout) {
      this.wsTimeout = setTimeout(() => {
        this.faroService.pushEvent('payment_timeout', {
          booking_reference: internal_id,
        });
        this.closeWebSocket();
        document.getElementById("openReloadButton").click();
      }, 10 * 60 * 1000);
    }
  }

  initiateSTKPush(data:any, internal, id) {
    let self = this
    this.itenaryservice.initiateStk(data).subscribe(
      data  => {
        this.res = data;
        setTimeout(function () {
          self.getBookingStatus(internal, id)
        }, 8000);
      },
      error  => {
        setTimeout(function () {
          self.getBookingStatus(internal, id)
        }, 8000);
      }
    );
  }

  backToHome() {
    document.getElementById("closeConfirmDialog").click();
    this.closeWebSocket();
    this.router.navigate(['/']);
  }

  retryConfirmation() {
    this.faroService.pushEvent('payment_confirmation_retry_clicked', {});
    document.getElementById("closeConfirmDialog").click();
    this.closeWebSocket();
    setTimeout(() => {
      this.confirmMpesa(this.confirmData);
    }, 3000);
  }

  confirmMpesa(dataReceived:any) {
    this.isWaiting = true;
    this.isSaving = false;
    this.waitingMessage = "Processing your payments please wait.....";
    let pay_id = dataReceived.data.booking_id;
    let transaction_id = dataReceived.data.transaction_id;

    let confirm_data = {
      "api_agent": "kiwi",
      "booking_id": pay_id,
      "transaction_id": transaction_id,
      "booking_test": 0
    }

    this.service.confirmV2(pay_id, confirm_data).subscribe(
      response => {
        this.res = response;
        var self = this;

        if(this.res.data.status == 'paid') {
          this.isWaiting = false;
          this.successMessage = "Payment processed successfully";
          let f = btoa(JSON.stringify(this.res));
          this.pushPaymentConfirmedFaroEvent({ status: this.res.data.status });
          this.openpanel.track('payment_completed', {}); this.router.navigate(['/booking-successful', f]);

        } else if(this.res.data.status == 'cancelled' || this.res.message.includes('cancelled')) {
          this.isWaiting = false;
          this.isError = true;
          this.errorMessage = "Sorry your payment request was canceled. Please try again";
          // No existing Mixpanel/OpenPanel event on this branch, unlike the
          // other two cancellation sites - genuine gap, not a mirror.
          this.faroService.pushEvent('payment_cancelled', {
            booking_reference: pay_id,
          });

          let fdata = {
            "flight_data": this.confirmData.booking_data.flight_data,
            "search_data": this.confirmData.booking_data.search_data,
            "isError": true,
            "errorMessage": 'cancelled'
          };
          const payJson = JSON.stringify(fdata);
          this.dataService.changePaymentMessage(Base64.encode(payJson));
          this.router.navigate(['/payments', Base64.encodeURI(payJson)]);

        } else {
          this.isWaiting = true;
          this.waitingMessage = "Processing your payments please wait.....";
          if (!this.legacyConfirmRetryTracked) {
            this.legacyConfirmRetryTracked = true;
            this.faroService.pushEvent('payment_confirmation_retry_loop_entered', {
              booking_reference: pay_id,
              source: 'status_pending',
            });
          }
          setTimeout(function () {
            self.confirmMpesa(dataReceived);
          }, 10000);
        }
      },
      error => {
        this.isError = true;
        this.isWaiting = true;
        this.waitingMessage = "Processing your payments please wait.....";
        this.api_error = new Error().deserialize(error.error.errors);
        var self = this;
        if (!this.legacyConfirmRetryTracked) {
          this.legacyConfirmRetryTracked = true;
          this.faroService.pushEvent('payment_confirmation_retry_loop_entered', {
            booking_reference: pay_id,
            source: 'http_error',
          });
        }
        setTimeout(function () {
          self.confirmMpesa(dataReceived);
        }, 10000);
      }
    );
  }
}
